import React from "react";

const SummaryIcon: React.FC = () => (
  <>
    <path
      d="M11.668 2.5V5.83333C11.668 6.29357 12.0411 6.66667 12.5013 6.66667H15.8346"
      stroke="currentColor"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.168 17.5H5.83464C4.91416 17.5 4.16797 16.7538 4.16797 15.8333V4.16667C4.16797 3.24619 4.91416 2.5 5.83464 2.5H11.668L15.8346 6.66667V15.8333C15.8346 16.7538 15.0884 17.5 14.168 17.5Z"
      stroke="currentColor"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7.5 7.5026H8.33333"
      stroke="currentColor"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 10.8307H12.5"
      stroke="currentColor"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 14.1667H12.5"
      stroke="currentColor"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
);

export default SummaryIcon;
